import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";

/**
 * this util checks if a given listing is of class type
 * @param param0 listingType The type of the listing to check
 * @returns
 */
export const checkIsListingClassesType = ({
    listingType,
}: {
    listingType: number;
}) => {
    return [
        LISTING_TYPES.GROUP_CLASSES,
        LISTING_TYPES.ROLLING_CLASSES,
        LISTING_TYPES.ONE_ON_ONE_CLASSES,
    ].includes(listingType);
};
